<script setup>
import { swalError } from '@/helper';
import { get_subscription, update_subscription } from '@/services/subscriptions';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const isLoading = ref(true)
const packageSub = ref({})
const features = ref([])
const temp_feature  = ref('')
const number_of_trait = ref()
const duration = ref()
const description = ref({id: '', value: ''})
const route = useRoute()
onMounted(async()=>{
  let response = await get_subscription(route.params.id)
  if (response.error){
    swalError(response.result.error)
    return
  }

  parseSubscription(response.result.data)
  isLoading.value = false
})

function parseSubscription(result){
  let data = result.data
  packageSub.value =  {...data.attributes}
  let meta = result.included
  let temp_fea = meta.find(item => item.attributes.key == 'features')
  features.value = {
    id: temp_fea.id,
    value: JSON.parse(meta.find(item => item.attributes.key == 'features')?.attributes.value)
  }
  const numItem = meta.find(item=>item.attributes.key == 'number_of_trait')
  number_of_trait.value = {
    id: numItem?.id || '',
    value: numItem?.attributes?.value || ''
  }
  const durationItem = meta.find(item=>item.attributes.key == 'duration')
  duration.value = {
    id: durationItem?.id || '',
    value: durationItem?.attributes?.value || ''
  }
  const descriptionItem = meta.find(item => item.attributes.key === 'description');
  description.value = {
    id: descriptionItem?.id || '',
    value: descriptionItem?.attributes?.value || ''
  }
}

function addFeature(){
  features.value.value.push(temp_feature.value)
  temp_feature.value = ''
}

function removeFeature(i){
  features.value.value.splice(i, 1)
}

async function submit(){
  let params = {
    ...packageSub.value,
    subscription_meta_attributes: [
      {
        id: features.value.id,
        key: 'features',
        value: JSON.stringify(features.value.value)
      },
      {
        id: number_of_trait.value.id,
        key: 'number_of_trait',
        value: number_of_trait.value.value
      },
      {
        id: duration.value.id,
        key: 'duration',
        value: duration.value.value
      },
      {
        id: description.value.id,
        key: 'description',
        value: description.value.value
      },
    ]
  }
  
  let response = await update_subscription(route.params.id, params)
  console.log("🚀 ~ submit ~ response:", response)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.message,
      icon: 'error'
    })
    return
  }

  Swal.fire({
    title: 'Updated',
    text: 'Package has been updated',
    icon: 'success'
  })
}

</script>

<template>
  <Breadcrumbs main="Edit Subscription Package"/>
  
  <div class="container-fluid">
    <div class="row">
      <!-- Item List -->
      <template v-if="isLoading">
        <loadingCard />
      </template>
      <template v-else>
        <div class="card">
          <div class="card-body">
            <!-- Package Name -->
            <div class="row">
              <!-- Package Name -->
              <div class="col-8">
                <div class="mb-3">
                  <label class="form-label" for="name">Package Name</label>
                  <!-- v-bind:class="formSubmitted ? nameError ? 'is-invalid' : 'is-valid' : ''"  -->
                  <input class="form-control" id="name" type="text"
                    placeholder="Sample Package"
                    required
                    v-model="packageSub.title"
                  >
                  <div class="form-text">
                    Package name to be displayed to client
                  </div>
                </div>
              </div>
              <!-- Price -->
              <div class="col-4">
                <div class="mb-3">
                  <label class="form-label" for="price">Price</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">RM</span>
                    <input type="text" 
                      class="form-control" 
                      placeholder="0"
                      v-model="packageSub.price"
                    >
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Package Description -->
            <div class="row">
              <!-- Duration -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="duration">Package Description</label>
                  <textarea class="form-control"
                    required
                    v-model="description.value"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- Duration & Number of Trait -->
            <div class="row">
              <!-- Duration -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="duration">Duration (days)</label>
                  <input class="form-control" id="duration" 
                    type="number"
                    placeholder="120"
                    required
                    v-model="duration.value"
                  >
                  <!-- <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <!-- Trait Count -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="trait_number">Number of Trait</label>
                  <input class="form-control" id="trait_number" 
                    type="number"
                    placeholder="2"
                    required
                    v-model="number_of_trait.value"
                  >
                  <!-- <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
            </div>
            
            <!-- Feature List -->
            <div class="row mt-4">
              <div class="col-12" v-auto-animate>
                <div>
                  <h6 class="mb-0">Feature</h6>
                </div>
                <form @submit.prevent="addFeature()" class="row mt-2">
                  <div class="col-6">
                    <input class="form-control" 
                      type="text" 
                      placeholder="Free consultation" required
                      v-model="temp_feature"
                    >
                  </div>
                  <div class="col-2">
                    <button type="submit" class="btn-rounded-icon p-0 btn btn-success"
                    >
                      <vue-feather type="plus"></vue-feather>
                    </button>
                  </div>
                </form>
                <!-- items -->
                <div v-for="(feature, index) in features.value" class="row mt-2" v-auto-animate>
                  <div class="col-6">
                    <input class="form-control" 
                      type="text" 
                      placeholder="Feature Description" required
                      :value="feature"
                      disabled
                    >
                  </div>
                  <div class="col-2">
                    <button class="btn-rounded-icon p-0 btn btn-danger"
                      @click="removeFeature(index)"
                    >
                      <vue-feather type="x"></vue-feather>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class=" d-flex justify-content-end mt-2">
              <button class="btn btn-light-success"
                @click="submit()"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
label.form-label{
  font-weight: 600;
}
</style>